import { Flex } from '@chakra-ui/react';
import React from 'react';
import ZaraLogo from '../../header/ZaraLogo';

const Loader = () => {
    return (
        <Flex
            top='0px'
            left='0px'
            pos='absolute'
            w='full'
            h='100vh'
            justifyContent='center'
            alignItems='center'
            bg='white'
            zIndex={3}
        >
            <ZaraLogo />
        </Flex>
    );
};

export default Loader;
